import {
    InterConnectionRevenueForm_FILE_CHANGE,
    InterConnectionChargeForm_TEXT_CHANGE,
    ComercialRevenueForm_TEXT_CHANGE,
    InterConnectionRevenueForm_TEXT_CHANGE,
    PaymentTermForm_TEXT_CHANGE,
    PrepaymentRevenueForm_TEXT_CHANGE,
    InterConnectionChargeForm_COMPANIES_TEXT_CHANGE,
    InterConnectionRevenueForm_COMPANIES_FILE_CHANGE,
    InterConnectionRevenueForm_COMPANIES_TEXT_CHANGE,
    RESET_FORM
} from '../types'

const initialState = {
    comercialRevenue: {
        equipment_sales: null,
        sim_cards: null,
        others1: null,
        others2: null,
        others3: null
    },
    interConnectionCharge: {
        international_calls: null,
        local_calls: null,
        media_comm_companies: null,
        accured_expense_itpc: null,
        roaming_calls: null,
        charges_paidfor_itpc: null,
        others1: null,
        others2: null,
        others3: null,
        companiesCharge: [],
        companiesChargeAttachment: []
    },
    interConnectionRevenue: {
        international_calls: null,
        international_calls_attachment: null,
        local_calls: null,
        local_calls_attachment: null,
        media_comm_companies: null,
        media_comm_companies_attachment: null,
        roaming_calls: null,
        roaming_calls_attachment: null,
        others1: null,
        others1_attachment: null,
        others2: null,
        others2_attachment: null,
        others3: null,
        others3_attachment: null,
        companiesRevenue: [],
        companiesRevenueAttachment: []
    },
    paymentTerm: {
        international_calls: null,
        roaming: null,
        gprs: null,
        vas: null,
        subscription_fees: null,
        device_broadband: null,
        local_calls: null,
        sms: null,
        mobile_internet: null,
        mms: null,
        connection_fees: null,
        others1: null,
        others2: null,
        others3: null
    },
    prepaymentRevenue: {
        international_calls: null,
        roaming: null,
        gprs: null,
        vas: null,
        subscription_fees: null,
        device_broadband: null,
        local_calls: null,
        sms: null,
        mobile_internet: null,
        mms: null,
        connection_fees: null,
        others1: null,
        others2: null,
        others3: null,
    }
};

// test

const formsReducer = (state = initialState, action) => {
    switch (action.type) {
        case InterConnectionRevenueForm_FILE_CHANGE:
            {
                let {
                    field,
                    value
                } = action.payload;
                state = {
                    ...state,
                    interConnectionRevenue: {
                        ...state.interConnectionRevenue,
                        [field]: value
                    }
                }
                return state;
            }

        case InterConnectionRevenueForm_TEXT_CHANGE:
            {
                let {
                    field,
                    value
                } = action.payload;
                state = {
                    ...state,
                    interConnectionRevenue: {
                        ...state.interConnectionRevenue,
                        [field]: value
                    }
                }
                return state;
            }

        case ComercialRevenueForm_TEXT_CHANGE:
            {
                let {
                    field,
                    value
                } = action.payload;
                state = {
                    ...state,
                    comercialRevenue: {
                        ...state.comercialRevenue,
                        [field]: value
                    }
                }
                return state;
            }

        case InterConnectionChargeForm_TEXT_CHANGE:
            {
                let {
                    field,
                    value
                } = action.payload;
                state = {
                    ...state,
                    interConnectionCharge: {
                        ...state.interConnectionCharge,
                        [field]: value
                    }
                }
                return state;
            }

        case PaymentTermForm_TEXT_CHANGE:
            {
                let {
                    field,
                    value
                } = action.payload;
                state = {
                    ...state,
                    paymentTerm: {
                        ...state.paymentTerm,
                        [field]: value
                    }
                }
                return state;
            }

        case PrepaymentRevenueForm_TEXT_CHANGE:
            {
                let {
                    field,
                    value
                } = action.payload;
                state = {
                    ...state,
                    prepaymentRevenue: {
                        ...state.prepaymentRevenue,
                        [field]: value
                    }
                }
                return state;
            }

        case InterConnectionChargeForm_COMPANIES_TEXT_CHANGE:
            {
                let {
                    companyID,
                    value
                } = action.payload;
                let {
                    interConnectionCharge
                } = state;
                let companiesCharge = interConnectionCharge.companiesCharge
                let index = companiesCharge.findIndex(c => c.companyID === companyID);
                if (index < 0) {
                    companiesCharge.push({
                        companyID,
                        value
                    })
                } else {
                    companiesCharge[index] = {
                        companyID,
                        value
                    }
                }
                state = {
                    ...state,
                    interConnectionCharge: {
                        ...interConnectionCharge,
                        companiesCharge
                    }
                }
                return state;
            }

        case InterConnectionRevenueForm_COMPANIES_TEXT_CHANGE:
            {
                let {
                    companyID,
                    value
                } = action.payload;
                let {
                    interConnectionRevenue
                } = state;
                let companiesRevenue = interConnectionRevenue.companiesRevenue;
                let index = companiesRevenue.findIndex(c => c.companyID === companyID);
                if (index < 0) {
                    companiesRevenue.push({
                        companyID,
                        value
                    })
                } else {
                    companiesRevenue[index] = {
                        companyID,
                        value
                    }
                }
                state = {
                    ...state,
                    interConnectionRevenue: {
                        ...interConnectionRevenue,
                        companiesRevenue
                    }
                }
                return state;
            }

        case InterConnectionRevenueForm_COMPANIES_FILE_CHANGE:
            {
                let {
                    companyID,
                    value
                } = action.payload;
                let {
                    interConnectionRevenue
                } = state;
                let companiesRevenueAttachment = interConnectionRevenue.companiesRevenueAttachment;
                let index = companiesRevenueAttachment.findIndex(c => c.companyID === companyID);
                if (index < 0) {
                    companiesRevenueAttachment.push({
                        companyID,
                        value
                    })
                } else {
                    companiesRevenueAttachment[index] = {
                        companyID,
                        value
                    }
                }
                state = {
                    ...state,
                    interConnectionRevenue: {
                        ...interConnectionRevenue,
                        companiesRevenueAttachment
                    }
                }
                return state;
            }
        case RESET_FORM:
            {
                return {
                    ...initialState,
                    interConnectionRevenue: {
                        ...initialState.interConnectionRevenue,
                        companiesRevenue: [],
                        companiesRevenueAttachment: [],
                    },
                    interConnectionCharge: {
                        ...initialState.interConnectionCharge,
                        companiesCharge: [],
                        companiesChargeAttachment: []
                    }
                }
            }
        default:
            return state;
    }
};


export default formsReducer;